module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAjCAYAAAD8BaggAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAURJREFUeNrEmGERwyAMhXtzMAu1gAUszAIWsFALWJiFWqiFWsACoze25XIMCkkod739KKNfk7yXbNMUVwhhjtcW3svHS00DVnyOCb9l8U2VYEKCuwvDKADjSpu+UMIwvggDNusqOQ3m3vzSKLcLM8zWVRYIyjABrem8vatGj5QBKE2EcSwq5jjokDSrpVBCLZH67mJEijUScv1APRu9xl5qaKkVeSkva4JqjSQXlP7XFIEAxPthVT3AIsbCZPwlsBkfAxR0czLMjWoF8eO6aBSi4y5PGSzgjML8aIXZnJpI8w6D3LOpGQoVD38ARalK39tF3Rq1DNO430nC2M7vLVwwMPyOUHP0mYirc7NBcaoFtRhFOWDnkm63m0u2AfSnxtyaby1gH+eNU+QnS33mzkOVxtIBRruOc9XzrcjVScfP5u4lwABO++wvBYX0uQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 1